<template>
  <header class="header">
    <div
      class="header_environment"
      :class="{'header_environment__success': !isTest, 'header_environment__danger': isTest}">
        <span v-if="isTest">Você está em ambiente de SANDBOX</span>
    </div>
    <article
      class="message is-warning message-remote-access is-marginless"
      v-if="remoteAccessInfo.active">
        <div class="message-body">
          Você está acessando a conta <strong>{{ remoteAccessInfo.user.email }}</strong> |
          ID: <strong>{{ clientId }}</strong>.
          Antes de alterar qualquer informação, verifique se está logado na conta correta.
        </div>
    </article>
    <div class="columns is-vcentered header_menu">
      <div class="column">
        <div class="columns is-vcentered">
          <div class="column is-narrow has-text-centered">
            <a href="/welcome/">
              <img
                src="https://s3-sa-east-1.amazonaws.com/intelipost-assets/images/logos/INTELIPOST_RGB.png"
                class="header__logo"
                alt="Intelipost" />
            </a>
          </div>
          <div class="column is-hidden-mobile">
            <sc-client-logo class="header__logo" />
          </div>
        </div>
      </div>
      <div class="column is-narrow is-hidden-mobile">
        <div class="columns is-vcentered">
          <div class="column is-one-quarter" v-if="!envVisibility">
            <sc-environment />
          </div>
          <div class="column is-narrow">
            <sc-user />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Auth } from '@intelipost-js/secure-providers';
  import ScEnvironment from '@/components/sc-environment/ScEnvironment';
  import ScUser from '@/components/sc-user/ScUser';
  import ScClientLogo from '@/components/sc-client-logo/ScClientLogo';

  const { mapState } = createNamespacedHelpers('permissions');

  export default {
    name: 'sc-header',
    props: {
      remoteAccessInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isTest: Auth.getUser() && !Auth.getUser().is_production,
      };
    },
    computed: {
      ...mapState([
        'envVisibility',
      ]),
      clientId() {
        if (this.remoteAccessInfo.active) {
          const { user } = this.remoteAccessInfo;
          return user.is_production ? user.client_id : user.sandbox_client_id;
        }

        return null;
      },
    },
    components: {
      ScEnvironment,
      ScUser,
      ScClientLogo,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

  .header {
    background-color: $white;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $grey-lighter;
    box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.1);
    position: fixed;
    top: 0;
    z-index: 9;
    width: 100%;

    &_menu {
      padding: .8rem;
    }

    &_environment {
      width: 100%;
      transition: background-color 500ms linear;
      z-index: 9;

      &__success {
        height: .3rem;
        background-color: $primary;
      }

      &__danger {
        background-color: #e84c3d;
        color: #ffffff;
        font-weight: 900;
        text-align: center;

        p {
          padding: .125rem;
        }
      }
    }
  }

  .header__logo{
    display: block;
    margin: auto;
    width: 150px;
    height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sc-header/ScHeader.vue?83985eea